interface FormikHelpersLike {
    setFieldValue: (path: string, value: any) => unknown;
    setFieldTouched: (path: string, touched: boolean, shouldValidate?: boolean) => unknown;
}

// Components that write to the form on a button click rather than through a field never fire a
// blur, so they mark the path touched themselves - FormNavigation only saves touched forms.
export const setFieldValueAndTouch = (formik: FormikHelpersLike, path: string, value: unknown) => {
    formik.setFieldValue(path, value);
    formik.setFieldTouched(path, true, false);
};
